<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">特殊成绩申请</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-if="teaAuthVisible" v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                        <el-input v-if="stuAuthVisible" v-model="queryForm.courseName" placeholder="课程名称" clearable></el-input>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                        <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i> {{ buttonName }}</el-button>
                    </div>
                </div>
            </div>
            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row v-if="teaAuthVisible">
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.semesterCode" placeholder="学年学期">
                        <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.courseName" placeholder="课程名称"></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.applyTypeCode" filterable placeholder="申请类型" clearable>
                        <el-option v-for="item in comboOption.applyType" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.auditState" placeholder="审核状态" clearable>
                        <el-option v-for="(item, index) in comboOption.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有特殊成绩申请记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>{{ item.stuName }}</p>
                        <p><label for="">学年学期：</label>{{ item.semesterName }}</p>
                        <p><label for="">课程名称：</label>{{ item.courseName }}</p>
                        <p><label for="">申请类型：</label>{{ item.applyTypeName }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput" >
                        <el-button v-if="item.submitState == '0'" type="warning" @click="modRec(item)">编辑</el-button>
                        <el-button v-if="item.submitState == '0'" type="success" @click="submitRec(item)">提交</el-button>
                        <el-button v-if="item.submitState == '0'" type="danger" @click="delRec(item)">删除</el-button>
                        <el-button v-if="item.submitState=='1' && item.auditAuth=='0'" type="primary" @click="showDetailInfo(item)">详情</el-button>
                        <el-button v-if="item.auditAuth == '1'" type="primary" @click="auditRec(item)">审核</el-button>
                        <el-button v-if="item.submitState=='1' || item.auditState!=''" @click="showAuditList(item)">审核信息</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="specialScoreApplyForm" :model="applyForm" label-width="100px" label-position="left" width="100%" :rules="curdRules">
                        <el-form-item label="编号" prop="id" v-show="false">
                            <el-input v-model="applyForm.id"></el-input>
                        </el-form-item>
                        <el-row>
                            <el-form-item v-show="teaAuthVisible && fieldVisible" label="学生" prop="stuInfo">
                                <el-autocomplete class="inline-input" v-model="stuInfo" :fetch-suggestions="querySearchStu" placeholder="可输入学号或姓名搜索学生"
                                      :trigger-on-focus="false" @clear="clearSelectStu" clearable style="width:100%;"></el-autocomplete>
                            </el-form-item>
                            <el-form-item v-show="stuAuthVisible || !fieldVisible" label="学生" prop="stuCode">
                                {{ applyForm.stuCode + ' - ' + applyForm.stuName }}
                                <el-input v-model="applyForm.stuCode" v-show="false"></el-input>
                                <el-input v-model="applyForm.stuName" v-show="false"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item v-show="fieldVisible" label="学年学期" prop="semesterCode">
                                <el-select v-model="applyForm.semesterCode" filterable :placeholder="semesterTips" style="width:100%;" @change="handleSemesterChange" :disabled="semesterDisable">
                                    <el-option v-for="item in comboOption.semester" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="!fieldVisible" label="学年学期">{{ applyForm.semesterName }}</el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item v-show="fieldVisible" label="申请课程" prop="relatedCode">
                                <el-select v-model="applyForm.relatedCode" filterable :placeholder="courseTips" style="width:100%;" @change="handleCourseChange" :disabled="courseDisable">
                                    <el-option v-for="item in comboOption.course" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="!fieldVisible" label="申请课程">{{ applyForm.courseName }}</el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item v-show="fieldVisible" label="申请类型" prop="applyTypeCode">
                                <el-select v-model="applyForm.applyTypeCode" filterable :placeholder="applyTypeTips" style="width:100%;" @change="handleApplyTypeChange" :disabled="applyTypeDisable">
                                    <el-option v-for="item in comboOption.curApplyType" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="!fieldVisible" label="申请类型">{{ applyForm.applyTypeName }}</el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item v-show="fieldVisible" label="成绩类型" prop="scoreType">
                                <el-select v-model="applyForm.scoreType" filterable :placeholder="scoreTypeTips" style="width:100%;" :disabled="scoreTypeDisable">
                                    <el-option v-for="item in comboOption.curScoreType" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="!fieldVisible" label="成绩类型">{{ applyForm.scoreTypeName }}</el-form-item>
                        </el-row>
                        <el-table :data="fileTableData" v-loading.body="fileTableLoading" element-loading-text="数据加载中"
                            style="width: 100%" :height="fileTableHeight" ref="multipleTable" stripe border fit>
                            <el-table-column label="附件" prop="fileName" align="center" min-width="40%"></el-table-column>
                            <el-table-column align="center" width="110">
                                <template slot="header" slot-scope="scope">
                                    <div v-show="attachmentOperateState">
                                        <el-button size="small" @click="uploadDialogVisible = true" type="success"><i class="el-icon-upload2"></i>&nbsp;上传</el-button>
                                        <!--<el-button size="small" @click="confirmDelFile" type="danger"><i class="el-icon-delete"></i></el-button>-->
                                    </div>
                                    <div v-if="!attachmentOperateState">操作</div>
                                </template>
                                <template slot-scope="scope">
                                    <el-button size="mini" @click="showAttachment(scope.row)" type="primary"><i class="el-icon-view"></i></el-button>
                                    <el-button v-show="attachmentOperateState" size="mini" @click="confirmDelFile(scope.row.id)" type="danger"><i class="el-icon-delete"></i></el-button>
                                    <!--
                                    <el-button size="small" @click="downloadAttachment(scope.row);" type="primary">
                                        <i class="el-icon-download"></i>&nbsp;下载
                                    </el-button>
                                    -->
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-form-item v-show="fieldVisible" label="申请理由" prop="applyReason">
                            <el-input v-model="applyForm.applyReason" placeholder="请填写申请理由" autoComplete="on" type="textarea"
                                :rows="10" show-word-limit maxlength="200"></el-input>
                        </el-form-item>
                        <el-form-item v-show="!fieldVisible" label="申请理由">{{ applyForm.applyReason }}</el-form-item>
                    </el-form>
                </el-scrollbar>

                <div v-if="auditAreaVisible" slot="footer" class="dialog-footer">
                    <audit ref="audit" :itemCode="auditParam" :relatedCode="selectRowData?selectRowData.id:''" :auditLevel="selectRowData?selectRowData.auditLevel:''"
                        @auditCallback="auditCallback"></audit>
                </div>

                <div v-if="fieldVisible" slot="footer" class="dialog-footer text-center">
                    <el-button type="primary" :disabled="formSubmiting" @click="saveRec">保 存</el-button>
                    <el-button style="margin-left: 10px;" type="success" :disabled="formSubmiting" @click="saveAndSubmitRec">提 交</el-button>
                    <el-button style="margin-left: 10px;" @click="dialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog title="附件上传" :visible.sync="uploadDialogVisible" width="90%" style="top:0;" @close="closeUploadDialog" append-to-body>
                <div class="attachmentUpload" style="width: 100%;">
                    <el-upload class="upload-demo" ref="uploadFile" drag action="#" :file-list="fileList" :http-request="getFile"
                        :multiple="multipleType" :auto-upload="false" :limit="10" :on-change="onChangeFile" :on-success="handleFilUploadSuccess"
                        :on-remove="handleRemove" :on-exceed="handleExceed">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            <div style="font-size:16px; font-weight:bold;"><em>点击上传</em></div>
                            <div style="margin-top:20px; font-size:14px;">
                                <el-tooltip placement="top">
                                    <div slot="content">
                                        允许上传的文件类型如下（单个文件大小{{ fileSizeLimit }}MB以内）<br/>
                                        文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx<br/>
                                        图片文件：jpg、jpeg、png、gif<br/>
                                        音/视频文件：mp3、mp4
                                    </div>
                                    <el-button plain>查看上传文件限制</el-button>
                                </el-tooltip>
                            </div>
                        </div>
                    </el-upload>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleUpload">确 定</el-button>
                    <el-button @click="closeUploadDialog">取 消</el-button>
                </span>
            </el-dialog>

            <el-dialog :title="fileName" :visible.sync="previewerDialogVisible" v-if="previewerDialogVisible" width="95%" top="10px" append-to-body>
                <div style="height:730px;">
                    <previewer ref="previewer" :fileInfo="fileInfo" :height="680"></previewer>
                </div>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="90%">
               <div>
                   <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450"></auditList>
               </div>
           </el-dialog>
        </div>
    </div>
</template>
<script>
    import { globalConfig } from 'static/config'
    import { confirmMsg, showNotify } from "utils/message";
    import previewer from 'views/file/simplePreviewer.vue';
    import audit from './audit.vue';
    import auditList from './auditList.vue';

    export default {
        components: {
            previewer,
            audit,
            auditList,
        },
        data() {
            return {
                userRole: null,
                stuAuthVisible: false,
                teaAuthVisible: false,
                buttonName: '新建',
                comboOption: {
                    semester: null,
                    dept: null,
                    major: null,
                    course: null,
                    scoreType: [
                        {'comboValue':'ps','comboName':'平时'},
                        {'comboValue':'qz','comboName':'期中'},
                        {'comboValue':'sx','comboName':'实训'},
                        {'comboValue':'qm','comboName':'期末'},
                    ],
                    curScoreType: null,
                    applyType: null,
                    curApplyType: null,
                    auditState: null,
                },
                semesterTips: '请先选择学生',
                semesterDisable: true,
                courseTips: '请先选择学生',
                courseDisable: true,
                scoreTypeTips: '请先选择学生',
                scoreTypeDisable: true,
                applyTypeTips: '请先选择学生',
                applyTypeDisable: true,
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: null,
                    semesterCode: null,
                    courseName: null,
                    applyTypeCode: null,
                    auditState: null,
                },
                queryDialogVisible: false,
                tableData: [],
                currentPage: 1,
                total: null,
                tableLoading: false,
                selectRowData: {},
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                fieldVisible: true,
                students: [],
                stuInfo: null,
                applyForm: {
                    id: '',
                    stuCode: '',
                    stuName: '',
                    relatedCode: '',
                    courseName: '',
                    semesterCode: '',
                    semesterName: '',
                    scoreType: '',
                    scoreTypeName: '',
                    applyTypeCode: '',
                    applyTypeName: '',
                    applyReason: '',
                    submitState: '',
                    auditItemCode: '',
                },
                curdRules: {
                    stuInfo: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            let isExist = false;

                            for(let i=0; i<this.students.length; i++){
                                if(this.students[i].value == this.stuInfo){
                                    this.applyForm.stuCode = this.students[i].stuCode;
                                    this.applyForm.stuName = this.students[i].stuName;
                                    this.semesterTips = '请选择学年学期';
                                    this.semesterDisable = false;
                                    this.courseTips = '请先选择学年学期';
                                    this.scoreTypeTips = '请先选择学年学期';
                                    this.applyTypeTips = '请先选择学年学期';
                                    isExist = true;

                                    break;
                                }
                            }

                            if(isExist == false){
                                this.applyForm.stuCode = '';
                                this.applyForm.stuName = '';
                                this.applyForm.semesterCode = '';
                                this.applyForm.relatedCode = '';
                                this.applyForm.scoreType = '';
                                this.applyForm.applyTypeCode = '';
                                this.semesterTips = '请先选择学生';
                                this.semesterDisable = true;
                                this.courseTips = '请先选择学生';
                                this.courseDisable = true;
                                this.applyTypeTips = '请先选择学生';
                                this.applyTypeDisable = true;
                                this.scoreTypeTips = '请先选择学生';
                                this.scoreTypeDisable = true;
                                callback(new Error("学生不存在"));
                            }else{
                                callback();
                            }
                        },
                        change: "blur",
                    }],
                    relatedCode: [{
                            required: true,
                            message: "请选择课程",
                            trigger: ["blur", "change"],
                        }
                    ],
                    applyTypeCode: [{
                            required: true,
                            message: "请选择申请类型",
                            trigger: ["blur", "change"],
                        }
                    ],
                    scoreType: [{
                            required: true,
                            message: "请选择成绩类型",
                            trigger: ["blur", "change"],
                        }
                    ],
                },
                formSubmiting: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,
                //附件相关参数
                attachmentOperateState: false,
                uploadDialogVisible: false,
                fileTableHeight: 250,
                fileTableData: [],
                fileTableLoading: false,
                uploadDialogVisible: false,
                multipleType: true, //上传 单个/多个文件//file: null, //上传选中的文件
                fileList: [], //上传选中的多个文件
                fileInfo: {
                    name: null,
                    type: null,
                    url: null,
                },
                previewerDialogVisible: false,
                fileName: null,
                fileSizeLimit: 100,
                //判断是否需要删除临时附件
                delTempFile: false,
            };
        },
        created(){
            this.init();
        },
        mounted() {
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            loadStateImg(row){
                if(row.auditState==='1'){
                    //通过
                    return require('image/mobile/auditState/tg.png');
                }else if(row.auditState==='2'){
                    //驳回
                    return require('image/mobile/auditState/bh.png');
                }else{
                   if(row.submitState === '1'){
                       if(row.auditLevel === '1'){
                           //待审核
                           return require('image/mobile/auditState/dsh.png');
                       }else{
                           //审核中
                           return require('image/mobile/auditState/shz.png');
                       }
                   }else{
                       //未提交
                       return require('image/mobile/auditState/wtj.png');
                   }
                }
            },
            async init(){
                await this.queryUserInfo();
                await this.queryAuditParam();
                await this.queryList();
                this.initCombo();
            },
            async queryUserInfo() {
                await this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        let roleInfo = userInfo.roles;

                        for (var roleCode in roleInfo) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole = roleInfo[roleCode];
                        }

                        if(this.userRole === '学生'){
                            this.stuAuthVisible = true;
                            this.applyForm.stuCode = userInfo.phone;
                            this.queryForm.stuCode = userInfo.phone;
                            // this.applyForm.stuCode = '242121218';
                            // this.queryForm.stuCode = '242121218';
                            this.applyForm.stuName = userInfo.name;
                            this.queryForm.stuName = userInfo.name;
                            // this.applyForm.stuName = '安书语';
                            // this.queryForm.stuName = '安书语';
                            this.stuInfo = this.applyForm.stuName + ' - ' + this.applyForm.stuCode;
                            this.buttonName = '申请';
                            this.semesterTips = '请选择学年学期';
                            this.semesterDisable = false;
                        }else{
                            this.teaAuthVisible = true;
                        }
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            async queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;

                await this.$api.scoreManage.specialScoreApply.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            scoreTypeFormatter(row){
                return this.handleScoreTypeStr(row.scoreType);
            },
            handleScoreTypeStr(scoreType){
                let resultStr = '';

                if(scoreType === '全部成绩'){
                    resultStr = scoreType;
                }else{
                    let tempScoreTypeArray = scoreType.split(',');

                    for(let i=0; i<tempScoreTypeArray.length; i++){
                        if(tempScoreTypeArray[i] == 'ps'){
                            resultStr += '平时,';
                        }else if(tempScoreTypeArray[i] == 'qz'){
                            resultStr += '期中,';
                        }else if(tempScoreTypeArray[i] == 'sx'){
                            resultStr += '实训,';
                        }else if(tempScoreTypeArray[i] == 'qm'){
                            resultStr += '期末,';
                        }
                    }

                    if(resultStr.length > 0) resultStr = resultStr.substring(0, resultStr.length-1);
                }

                return resultStr;
            },
            requeryList(){
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            handleFilter() {
                this.requeryList();
                this.queryDialogVisible = false;
            },
            handleReset() {
                if(this.teaAuthVisible){
                    this.queryForm.stuCode = null;
                }
                this.queryForm.semesterCode = null;
                this.queryForm.courseName = null;
                this.queryForm.applyTypeCode = null;
                this.queryForm.auditState = null;
                this.requeryList();
                this.queryDialogVisible = false;
            },
            initCombo() {
                this.$api.scoreManage.specialScoreApply.initCombo({}).then((res) => {
                    this.comboOption.semester = res.data.data.semesterComboData;
                    this.comboOption.dept = res.data.data.deptComboData;
                    this.comboOption.major = res.data.data.majorComboData;
                    this.comboOption.class = res.data.data.classComboData;
                    this.comboOption.applyType = res.data.data.applyTypeComboData;
                    this.students = res.data.data.stuData;
                    this.comboOption.auditState = res.data.data.auditStateComboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            async handleSemesterChange(value){
                this.applyForm.relatedCode = '';
                this.applyForm.applyTypeCode = '';
                this.applyForm.scoreType = '';

                if(value === ''){
                    this.courseTips = '请先选择学年学期';
                    this.courseDisable = true;
                    this.applyTypeTips = '请先选择学年学期';
                    this.applyTypeDisable = true;
                    this.scoreTypeTips ='请先选择学年学期';
                    this.scoreTypeDisable = true;
                }else{
                    this.courseTips = '请选择申请课程';
                    this.courseDisable = false;
                    this.applyTypeTips = '请先选择申请课程';
                    this.applyTypeDisable = true;
                    this.scoreTypeTips ='请先选择申请课程';
                    this.scoreTypeDisable = true;

                    await this.$api.scoreManage.specialScoreApply.loadCourseCombo({
                        data: this.applyForm,
                    }).then((res) => {
                        this.comboOption.course = res.data.data.courseComboData;
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
            handleCourseChange(value){
                this.applyForm.applyTypeCode = '';
                this.applyForm.scoreType = '';

                if(value === ''){
                    this.applyTypeTips = '请先选择申请课程';
                    this.applyTypeDisable = true;
                    this.scoreTypeTips ='请先选择申请课程';
                    this.scoreTypeDisable = true;
                }else{
                    this.applyTypeTips = '请选择申请类型';
                    this.applyTypeDisable = false;
                    this.scoreTypeTips ='请先选择申请类型';
                    this.scoreTypeDisable = true;

                    //获取当前课程信息
                    let courseInfo;
                    for(let i=0; i<this.comboOption.course.length; i++){
                        if(this.comboOption.course[i].comboValue === value){
                            courseInfo = this.comboOption.course[i].otherInfo.split(',');
                            break;
                        }
                    }

                    this.comboOption.curApplyType = [];
                    //体育课处理
                    for(let i=0; i<this.comboOption.applyType.length; i++){
                        if(this.comboOption.applyType[i].comboName.indexOf('体育') > -1){
                            if(!courseName || courseName.indexOf('体育')<0){
                                continue;
                            }
                        }
                    
                        this.comboOption.curApplyType.push(this.comboOption.applyType[i]);
                    }
                    
                    this.comboOption.curScoreType = [];
                    //成绩类型处理
                    for(let i=0; i<this.comboOption.scoreType.length; i++){
                        if(this.comboOption.scoreType[i].comboName.indexOf('实训') > -1){
                            if(!courseInfo || courseInfo[1]==='0'){
                                continue;
                            }
                        }
                    
                        this.comboOption.curScoreType.push(this.comboOption.scoreType[i]);
                    }
                }
            },
            handleApplyTypeChange(value){
                this.applyForm.scoreType = '';

                if(value === ''){
                    this.scoreTypeTips ='请先选择申请类型';
                    this.scoreTypeDisable = true;
                }else if(value==='1' || value==='3'){
                    this.applyForm.scoreType = '全部成绩';
                    this.scoreTypeDisable = true;
                }else{
                    this.scoreTypeTips ='请选择成绩类型';
                    this.scoreTypeDisable = false;
                }
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelectStu(item){
                this.applyForm.stuCode = item.stuCode;
                this.applyForm.stuName = item.stuName;
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            addRec(){
                this.dialogTitle = "新建";
                this.dialogVisible = true;
                this.attachmentOperateState = true;
                this.applyForm.submitState = '0';
                this.applyForm.tempApplyCode = this.generateUUID();
                this.delTempFile = false;

                this.setMainDialogStyle('-60px', '80vh');
                this.restoreScroll();
            },
            generateUUID() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            modRec(rowData) {
                this.selectRowData = rowData;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });

                    return;
                }

                this.queryAttachmentList();
                this.dialogTitle = "编辑";
                this.dialogVisible = true;
                this.attachmentOperateState = true;
                this.setMainDialogStyle('-60px', '80vh');
                this.restoreScroll();
                this.$nextTick(() => {
                    this.fillForm();
                });
            },
            async fillForm(){
                this.applyForm.id = this.selectRowData.id;
                this.stuInfo = this.selectRowData.stuName + ' - ' + this.selectRowData.stuCode;
                this.applyForm.stuCode = this.selectRowData.stuCode;
                this.applyForm.stuName = this.selectRowData.stuName;

                this.applyForm.semesterCode = this.selectRowData.semesterCode;
                this.applyForm.semesterName = this.selectRowData.semesterName;
                await this.handleSemesterChange(this.applyForm.semesterCode);

                this.courseTips = '请选择申请课程';
                this.courseDisable = false;
                this.applyForm.relatedCode = this.selectRowData.relatedCode;
                this.applyForm.courseName = this.selectRowData.courseName;
                await this.handleCourseChange(this.applyForm.relatedCode);

                this.applyTypeTips = '请选择申请类型';
                this.applyTypeDisable = false;
                this.applyForm.applyTypeCode = this.selectRowData.applyTypeCode;
                this.applyForm.applyTypeName = this.selectRowData.applyTypeName;
                await this.handleApplyTypeChange(this.applyForm.applyTypeCode);

                if(this.applyForm.applyTypeCode==='1' || this.applyForm.applyTypeCode==='3'){
                    this.scoreTypeTips ='全部成绩';
                    this.scoreTypeDisable = true;
                    this.applyForm.scoreType = '全部成绩';
                }else{
                    this.scoreTypeTips ='请选择成绩类型';
                    this.scoreTypeDisable = false;
                    this.applyForm.scoreType = this.selectRowData.scoreType;
                    this.applyForm.scoreTypeName = this.handleScoreTypeStr(this.applyForm.scoreType);
                }

                this.applyForm.applyReason = this.selectRowData.applyReason;
                this.applyForm.submitState = this.selectRowData.submitState;

                this.queryAttachmentList();
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['specialScoreApplyForm'].validate((valid) => {
                    if (valid) {
                        this.$api.scoreManage.specialScoreApply.save({
                            data: this.applyForm,
                        }).then((response) => {
                            let state = response.data.data.state;
                            let msg = response.data.data.msg;

                            if (state == 'Success') {
                                showNotify('成功', msg ? msg : "保存成功", 'success', 1500);

                                this.currentPage = 1;
                                this.delTempFile = false;
                                this.queryList();
                                this.closeDialog();
                                this.formSubmiting = false;
                            }else{
                                showNotify('失败', msg ? msg : "保存失败", 'error', 3000);
                                this.formSubmiting = false;
                            }
                        }).catch((error) => {
                            showNotify('错误', error, 'error', 3000);
                            this.formSubmiting = false;
                        });
                    } else {
                        this.formSubmiting = false;
                        return false;
                    }
                });
            },
            saveAndSubmitRec(){
                //提交前判断是否上传了附件
                if(this.fileTableData.length === 0){
                    this.$alert("请先上传相关附件", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });

                    return;
                }

                confirmMsg('提交后将无法再修改特殊成绩申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.applyForm.submitState = '1';
                    this.saveRec();
                });
            },
            submitRec(rowData){
                confirmMsg('提交后将无法再修改特殊成绩申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.$api.scoreManage.specialScoreApply.submit({
                        data: {
                            id: rowData.id,
                            auditItemCode: this.applyForm.auditItemCode,
                        },
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '提交成功', 'success', 1500);
                            this.requeryList();
                        }else{
                            if(state == 'NoFile'){
                                this.$alert("请先上传相关附件", "提示", {
                                    confirmButtonText: "确定",
                                    customClass: 'el-message-box-mobile',
                                });
                            }else{
                                showNotify('失败', '提交失败', 'error', 3000);
                            }
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除特殊成绩申请信息？', 'el-message-box-mobile').then(() => {
                    this.applyForm.id = rowData.id;

                    this.$api.scoreManage.specialScoreApply.del({
                        data: this.applyForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', "删除成功", 'success', 1500);

                            this.currentPage = 1;
                            this.queryList();
                        }else{
                            showNotify('失败', "删除失败", 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            closeDialog() {
                //删除临时附件
                if(this.delTempFile){
                    this.delFileByCode();
                }

                if(this.$refs['specialScoreApplyForm'] !== undefined){
                    this.$refs['specialScoreApplyForm'].resetFields();
                }

                if(this.userRole != '学生'){
                    this.stuInfo = '';
                    this.semesterTips = '请先选择学生';
                    this.semesterDisable = true;
                }
                this.applyForm.id = '';

                this.courseTips = '请先选择学生';
                this.courseDisable = true;
                this.applyTypeTips = '请先选择学生';
                this.applyTypeDisable = true;
                this.scoreTypeTips ='请先选择学生';
                this.scoreTypeDisable = true;

                this.dialogVisible = false;
                this.fieldVisible = true;
                this.auditAreaVisible = false;

                this.attachmentOperateState = false;
                this.fileTableData = [];
                this.selectRowData = {};
                this.applyForm.tempApplyCode = '';
                this.delTempFile = false;
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.dialogTitle = '详情';
                this.setMainDialogStyle('-60px', '85vh');
                this.dialogVisible = true;
                this.dialogVisible = true;
                this.fieldVisible = false;
                this.fillForm();
            },
            //查询审核调用参数
            async queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                await this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.auditParam = res.data.data.auditParam;
                    this.queryForm.itemCode = this.auditParam;
                    this.applyForm.auditItemCode = this.auditParam;
                }).catch((err) => {
                    console.log(err);
                });
            },
            auditRec(rowData){
                this.selectRowData = rowData;
                this.dialogTitle = '审核';
                this.setMainDialogStyle('-60px', '65vh');
                this.dialogVisible = true;
                this.fieldVisible = false;
                this.auditAreaVisible = true;

                this.fillForm();
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.dialogVisible = false;
                auditInfo.id = this.selectRowData.id;
                auditInfo.stuCode = this.selectRowData.stuCode;
                auditInfo.relatedCode = this.selectRowData.relatedCode;
                auditInfo.applyTypeCode = this.selectRowData.applyTypeCode;
                auditInfo.scoreType = this.selectRowData.scoreType;

                this.updateAuditState(auditInfo);
            },
            //完成审核后更新学生成绩信息
            updateAuditState(auditInfo){
                this.$api.scoreManage.specialScoreApply.updateAuditState({
                    data: auditInfo,
                }).then((response) => {
                    let state = response.data.data.state;
                    if(state !== 'Success'){
                        showNotify('失败', '成绩信息更新失败', 'error', 3000);
                    }

                    this.queryList();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queryAttachmentList(){
                this.fileTableLoading = true;
                let applyCode;
                if(this.selectRowData && this.selectRowData.id!=undefined){
                    applyCode = this.selectRowData.id;
                }else{
                    applyCode = this.applyForm.tempApplyCode;
                }

                this.$api.scoreManage.specialScoreApply.attachmentList({
                    data: { applyCode:applyCode },
                }).then((response) => {
                    this.fileTableData = response.data.data.list;
                    this.fileTableLoading = false;
                }).catch((error) => {
                    this.fileTableLoading = false;
                    console.log(error);
                });
            },
            //http-request上传方法（未使用）
            getFile(fileObj) {
                this.file = fileObj.file;
                //this.handleUpload(fileObj);
            },
            //当上传文件有变更时
            onChangeFile(file, fileList) {
                //文件类型限制
                let fileTypeArray = [];
                fileTypeArray.push('txt','doc','docx','xls','xlsx','pdf', 'ppt');//文本文件
                fileTypeArray.push('jpg','jpeg','png','gif');//图片
                fileTypeArray.push('mp3');//音频
                fileTypeArray.push('mp4');//视频
                let suffix = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase();
                //文件大小限制
                const sizeLimit = this.fileSizeLimit * 1024 * 1024;

                //判断文件类型及大小是否符合要求
                if (fileTypeArray.indexOf(suffix) < 0 || file.size > sizeLimit) {
                    this.$message({
                        message: '不符合要求的文件已自动过滤',
                        type: 'error'
                    });

                    let index = fileList.findIndex( fileItem => {
                        return fileItem.uid === file.uid
                    });
                    fileList.splice(index, 1); //从上传文件列表删除当前选中文件
                } else {
                    this.fileList = [];
                    this.fileList = fileList;
                }
            },
            //上传文件
            handleUpload() {
                /* let repeatFlag = false;
                for(let i=0; i<this.fileList.length; i++){
                    for(let j=0; j<this.fileTableData.length; j++){
                        if(this.fileList[i].name == this.fileTableData[j].fileName + '.' + this.fileTableData[j].fileType){
                            repeatFlag = true;
                        }
                    }
                }
                if(repeatFlag){
                    confirmMsg('存在相同名称的文件，上传将覆盖原文件，是否确定上传？', 'el-message-box-mobile').then(() => {
                        this.uploadFile();
                    });

                    return;
                } */

                if(this.fileList.length === 0){
                    this.$message({
                        message: '请先选择上传的文件',
                        type: 'warning'
                    });

                    return;
                }

                this.uploadFile();
            },
            uploadFile(){
                const loading = this.$loading({
                    lock: true,
                    text: '文件上传中，请稍候...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                //添加参数
                var formData = new FormData();
                for (let i=0; i<this.fileList.length; i++) {
                    formData.append("files", this.fileList[i].raw);
                }
                if(this.selectRowData && this.selectRowData.id!=undefined){
                    formData.append("applyCode", this.selectRowData.id);
                }else{
                    formData.append("applyCode", this.applyForm.tempApplyCode);
                }

                this.$api.scoreManage.specialScoreApply.uploadMultiFile({
                    data: formData,
                }).then(response => {
                    if (response.data.data.state == "Success") {
                        showNotify('成功', '上传成功', 'success', 1500);

                        this.uploadDialogVisible = false;
                        this.fileList = [];
                        this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                        this.queryAttachmentList();
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                    }

                    loading.close();
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                    this.fileList = [];
                    this.$refs.uploadFile.clearFiles(); //把之前上传的清空
                    loading.close();
                });
            },
            handleRemove(file, fileList) {
                //console.log(file,fileList);
                this.fileList = [];
                this.fileList = fileList;
            },
            closeUploadDialog() {
                this.uploadDialogVisible = false;
                this.fileList = [];
                this.$refs.uploadFile.clearFiles();
            },
            handleExceed(files, fileList) {
                this.$message.warning(`每次上传限制最多选择10个文件`);
            },
            // 文件上传成功时的函数
            handleFilUploadSuccess(res, file, fileList) {
                // console.log(res, file, fileList)
                this.$message.success("上传成功")
            },
            confirmDelFile(id) {
                /* if (this.$refs.multipleTable.selection.length == 0) {
                    this.$message({
                        title: '提示',
                        message: '请选择要删除的附件！',
                        type: 'warning',
                        duration: 2000,
                    });
                    return;
                } */

                confirmMsg('此操作将永久删除附件信息, 是否继续?', 'el-message-box-mobile').then(() => {
                    this.delFileById(id);
                });
            },
            delFileById(id){
                // let selectArray = this.$refs.multipleTable.selection;
                // let selections = "";
                // for (let i=0; i<selectArray.length; i++) {
                //     selections += selectArray[i].id + ",";
                // }
                // if (selections.length > 0) {
                //     selections = selections.substring(0, selections.length - 1);
                // }

                this.$api.scoreManage.specialScoreApply.delFileById({
                    data: {
                        id: id,
                    }
                }).then(response => {
                    let state = response.data.data.state;

                    if (state == 'Success') {
                        showNotify('成功', '删除成功', 'success', 1500);
                        this.queryAttachmentList();
                    }else{
                        showNotify('失败', '删除成功', 'error', 3000);
                    }
                }).catch(error => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            delFileByCode(){
                this.$api.scoreManage.specialScoreApply.delFileByCode({
                    data: {
                        applyCode: this.applyForm.tempApplyCode,
                    }
                }).then(response => {
                    if (state == 'Success') {
                        console.log('删除临时附件成功');
                    }else{
                        console.log('删除临时附件失败');
                    }
                }).catch(error => {
                    console.log('删除临时附件失败');
                });
            },
            showAttachment(rowData){
                this.fileInfo.name = rowData.fileName;
                this.fileInfo.type = rowData.fileType;
                this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.previewPath;
                this.fileName = rowData.fileName + '.' + rowData.fileType;
                this.previewerDialogVisible = true;
            },
            downloadAttachment(rowData){
                const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + rowData.filePath;
                let exist = this.isExistFile(fileUrl);
                if (exist) {
                    this.downloadFile(fileUrl, rowData.fileName+'.'+rowData.fileType);
                } else {
                    showNotify('错误', '文件不存在，如有疑问请联系管理员！', 'error', 3000);
                }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            //显示审核详情列表
            showAuditList(rowData){
                this.selectRowData = rowData;
                this.auditListDialogVisible = true;
            },
            setMainDialogStyle(top, height){
                document.getElementById('mainDialog').style.top = top;
                this.$nextTick(() => {
                    document.getElementById('mainDialogScroll').style.height = height;
                });
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
        },
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode {
        line-height: 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }

    .attachmentUpload /deep/ .el-upload-dragger {
        width: 80vw;
        height: 180px;
    }

    .attachmentUpload /deep/ .el-upload-dragger .el-icon-upload {
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// specialScoreApply.vue?083fba62